import type { Color } from "deck.gl";

export function deckGlColourToRgba(colour: Color): string {
  const rgb = colour.slice(0, 3);
  const a = (colour[3] ?? 255) / 255;
  const rgba = [...rgb, a];
  return `rgba(${rgba.join(", ")})`;
}
